module.exports = __webpack_public_path__ + "img/topimage3.0bb067bd.png";